if(!customElements.get('horizontal-complementary-products')){
    class HorizontalComplementaryProducts extends HTMLElement {
        constructor(){
            super();

            this.fetchURL = this.dataset.url;
        }

        connectedCallback(){
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                if(!this.fetchURL) return;
                fetch(this.fetchURL)
                .then(res => res.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;

                    const complementaryProducts = html.querySelector('horizontal-complementary-products');

                    if(complementaryProducts && complementaryProducts.innerHTML.trim().length){
                        this.innerHTML = complementaryProducts.innerHTML;
                    }
                }).catch(e => {
                    console.error(e);
                });
            }

            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 0px 0px'}).observe(this);
        }
    }

    customElements.define('horizontal-complementary-products', HorizontalComplementaryProducts);
}